module.exports = __webpack_public_path__ + "1458a3eb378a0ed1315db20dd9e5d1dc.svg";